import "./LeftMenuButton.scss";
import {
  Speedometer02,
  MagicWand02,
  ClipboardCheck,
  PencilLine,
} from "@untitled-ui/icons-react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import ToolTip from "../ToolTip/ToolTip";

// Tooltip for buttons that only pass a page id
const PAGE_TOOLTIP_KEYS = {
  superdashboard: "topBar.pages.superdashboard",
  dashboard: "topBar.pages.dashboard",
  tasks: "topBar.pages.tasks",
  notes: "topBar.pages.notes",
  todolists: "topBar.pages.todolists",
  demo: "topBar.pages.demo",
};

function LeftMenuButton({
  isActive,
  onClick,
  page,
  tooltip,
  hasTopBorder,
  icon,
  variant,
  size,
}) {
  const { t } = useTranslation();
  const toolTipRef = useRef();

  const showToolTip = (e, arrow, content) => {
    const triggerElement = e.currentTarget;

    if (toolTipRef.current) {
      toolTipRef.current.open({
        arrow,
        content,
        triggerElement,
      });
    }
  };

  const capitalizeWords = (str) => {
    return str
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getTooltipText = () => {
    if (tooltip) return tooltip;
    return PAGE_TOOLTIP_KEYS[page]
      ? t(PAGE_TOOLTIP_KEYS[page])
      : capitalizeWords(page);
  };

  const standardIconSize = "20px";

  return (
    <>
      <ToolTip ref={toolTipRef} />

      <div
        className={`left-menu-button ${isActive ? "active" : ""} ${hasTopBorder ? "has-top-border" : ""} ${variant ? `variant-${variant}` : ""}`}
        onClick={onClick}
        onMouseEnter={(e) => showToolTip(e, "left-center", getTooltipText())}
      >
        {icon && (
          <span
            className="material-symbols-outlined"
            style={{ fontSize: icon ? size : standardIconSize }}
          >
            {icon}
          </span>
        )}
        {!icon && page === "superdashboard" && (
          <span
            className="material-symbols-outlined"
            style={{ fontSize: icon ? size : standardIconSize }}
          >
            wand_stars
          </span>
        )}
        {!icon && page === "dashboard" && (
          <span
            className="material-symbols-outlined"
            style={{ fontSize: icon ? size : standardIconSize }}
          >
            swap_driving_apps_wheel
          </span>
        )}
        {!icon && page === "tasks" && (
          <span
            className="material-symbols-outlined"
            style={{ fontSize: icon ? size : standardIconSize }}
          >
            checklist
            {/* assignment */}
          </span>
        )}
        {!icon && page === "notes" && (
          <span
            className="material-symbols-outlined"
            style={{ fontSize: icon ? size : standardIconSize }}
          >
            {/* note_stack */}
            {/* sticky_note_2 */}
            edit_document
          </span>
        )}
        {!icon && page === "todolists" && (
          <span
            className="material-symbols-outlined"
            style={{ fontSize: icon ? size : standardIconSize }}
          >
            {/* task_alt */}
            format_list_bulleted
          </span>
        )}
        {!icon && page === "demo" && (
          <span
            className="material-symbols-outlined"
            style={{ fontSize: icon ? size : standardIconSize }}
          >
            stars_2
          </span>
        )}
      </div>
    </>
  );
}

export default LeftMenuButton;
